module.exports = __webpack_public_path__ + "img/white-tag.94ccdb92.svg";